
define('text!plugins/boolean/setupTemplate.html',[],function () { return '';});

